export const formatDate = (date) => {
  const localDate = new Date(date.endsWith("Z") ? date : date + "Z");
  return localDate.toLocaleString("en-GB", { hour12: false });
};
